import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SOLUTIONS } from '../data/solutions';
import { BOOK_DEMO_URL, GET_STARTED_URL } from '../data/dgpt';
import { usePageMeta, canonicalUrl } from '../hooks/usePageMeta';
import { PageHero } from '../components/platform/PageHero';
import { CtaButton } from '../components/ui/CtaButton';
import { SolutionBlock } from '../components/solutions/SolutionBlock';
import { SolutionsStackDiagram } from '../components/platform/SolutionsStackDiagram';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Reveal } from '../components/ui/Reveal';
import { ProcessCta } from '../components/platform/ProcessCta';
export function Solutions() {
  usePageMeta({
    title: 'Due Diligence Solutions | Investment, Procurement, Acquisitions & Grants | DiligenceGPT™',
    description: 'One agentic diligence stack for investment, procurement and vendor, acquisition, applications and grants, organizational risk and continuous due diligence.',
    path: '/solutions',
    keywords: ['investment due diligence', 'vendor due diligence software', 'acquisition due diligence', 'grant application review', 'third party risk', 'continuous due diligence'],
    jsonLd: [{
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: canonicalUrl('/')
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'Solutions',
        item: canonicalUrl('/solutions')
      }]
    }]
  });
  return <main id="main" data-id="element-1661" data-mp="2mffecsqv1euk">
      <PageHero headingId="solutions-page-heading" breadcrumb="Solutions" eyebrow="Solutions" title="Due Process for Every High Stakes Decision." description="Investment, procurement, acquisitions, applications, organizational diligence and monitoring — each one runs on the same agents, with your team deciding." actions={<>
            <CtaButton href={GET_STARTED_URL} variant="violet" size="xl" event="primary_cta_click" eventParams={{
        placement: 'solutions_hero',
        cta: 'build_first_process'
      }} className="w-full sm:w-auto" data-id="element-1663" data-mp="23mbjx55tixyw">
              Build Your First Process
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1664" data-mp="20dx0g0o2dvwm" />
            </CtaButton>
            <CtaButton href={BOOK_DEMO_URL} variant="outlineDark" size="xl" event="enterprise_demo_click" eventParams={{
        placement: 'solutions_hero'
      }} className="w-full sm:w-auto" data-id="element-1665" data-mp="20g9jyi9h0ebs">
              Book a Demo
            </CtaButton>
          </>} data-id="element-1662" data-mp="2menlvqsk7x8i" />

      <nav aria-label="Solutions" className="sticky top-16 z-20 border-b border-hairline bg-ink/95 backdrop-blur-xl lg:top-[72px]" data-id="element-1666" data-mp="1hmmfs18xmfd6">
        <ul className="sf-scrollbar mx-auto flex w-full max-w-[1320px] gap-2 overflow-x-auto px-4 py-3 sm:px-6 lg:px-8" data-id="element-1667" data-mp="2y3i9qpgi89jl">
          {SOLUTIONS.map(solution => <li key={solution.id} className="shrink-0" data-id="element-1668" data-mp="30lbz8tykk7ru">
              <a href={`#${solution.id}`} className="inline-flex min-h-[40px] items-center rounded-full border border-hairline bg-panel px-4 text-[13px] font-semibold text-text-secondary transition-colors hover:border-lime/40 hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1669" data-mp="35kwyl5hnii53">
                {solution.label}
              </a>
            </li>)}
        </ul>
      </nav>

      <div className="bg-surface" data-id="element-1670" data-mp="3odio781ytch8">
        <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-6 px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-1671" data-mp="3akt2l4qcm9kn">
          {SOLUTIONS.map((solution, index) => <SolutionBlock key={solution.id} solution={solution} index={index} data-id="element-1672" data-mp="3ejibol4ct4yh" data-mpi={index} />)}
        </div>
      </div>

      <section aria-labelledby="same-stack-heading" className="border-b border-hairline-soft bg-ink" data-id="element-1673" data-mp="awjd0puey3o0">
        <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-1674" data-mp="2jdkqxwy25s84">
          <SectionHeading eyebrow="One platform" headingId="same-stack-heading" title="Different Processes. Same Infrastructure." align="center" data-id="element-1675" data-mp="2eerdg4iru17y" />
          <Reveal className="mt-12" data-id="element-1676" data-mp="29gg19n507emk">
            <SolutionsStackDiagram data-id="element-1677" data-mp="29hhnmnrgznjl" />
          </Reveal>
        </div>
      </section>

      <ProcessCta placement="solutions" data-id="element-1678" data-mp="25g5vobl4iq88" />
    </main>;
}